/**
 * Small helpers used by main.ts to keep the wiring file lean.
 */

/** Escape HTML so untrusted display text doesn't inject markup into overlays. */
export function escapeInline(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}
